<div class="alert alert-warning d-flex align-items-center p-2" role="alert">
  <span class="mts-icon mx-2">warning</span>
  <div class="fs-verysmall">
    {{  message }}
    @if (linkText) {
      <app-link (click)="selected($event)" [title]="linkText" [style]="'alert'">{{ linkText }}</app-link>
    }
  </div>
</div>
